import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { paymentLinkActions } from '../../../redux/slices/paymentLinkSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useSetLookupPrice = () => {
    const dispatch = useAppDisPatch();
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onSetLookupPriceError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while setting lookup price.',
        );
    };

    const onSetLookupPriceSuccess = (resetFn: (...args: any) => void) => ({
        data,
        message,
    }: SuccessHttpResponse<ISetLookupPriceData>) => {
        resetFn();
        dispatch(paymentLinkActions.setPaymentData(data));
    };

    const setLookupPrice = (data: any, resetFn: (...args: any) => void) => {
        const url: HttpConfig = {
            url: `api/v1/company/lookup/purchase`,
            method: 'post',
            data,
        };

        request(url, onSetLookupPriceSuccess(resetFn), setLoading, onSetLookupPriceError);
    };

    return { setLookupPrice, loading };
};

export default useSetLookupPrice;

export interface ISetLookupPriceData {
    "accessCode": string;
    "amount": number;
    "amountInMinor": number;
    "authorizationUrl": string;
    "availableLookUpCount": number;
    "createdAt": string;
    "gatewayMessage": string;
    "id": string;
    "paymentMethod": string | null;
    "paymentProvider": string;
    "paymentStatus": string;
    "quantity": number;
    "transactionRef": string;
}
